import {
	Typography
} from '@apostrophe/ui';
import {
	setAlert,setAlertNextPage
} from 'helpers/alertHelpers';
import { addPaymentInfo } from 'helpers/dataLayerHelpers';
import {
	createTokenAndPostCheckout, stripeTokenSave
} from 'helpers/paymentHelpers';
import { get } from 'lodash';
import isEmpty from 'lodash/isEmpty';
import React, {
	useEffect, useReducer, useState
} from 'react';
import {
	CardElement,injectStripe,
} from 'react-stripe-elements';
import { variables } from 'styleUtils';

import { productData } from '../../../Header'
import {
	CartItem,
	CartWrapper,
	OrderConfirmationWrapper,
} from '../../Version2/styles';
import { Title } from '../../Version3/styles';
import {
	ButtonWrapper,
	CreditCardInputWrapper,
	Disclaimer,
	Error, StyledButton, UpdatedRegistrationButtonWrapper
} from './styles';

const Button = ({
	bodyBusy, disabled, card, buttonText, onClick, useUpdatedRegistration,
}) => {
	return useUpdatedRegistration ? (
		<ButtonWrapper>
			<StyledButton
				onClick={onClick}
				disabled={bodyBusy || disabled || !card.complete}
			>
				{buttonText}
			</StyledButton>
		</ButtonWrapper>
	) : (
		<ButtonWrapper>
			<button
				onClick={onClick}
				disabled={bodyBusy || disabled || !card.complete}
			>
				{buttonText}
			</button>
		</ButtonWrapper>
	);
}

const reducer = (prevState, newState) => ({
	...prevState,
	...newState,
});
const CardForm = (props) => {
	const productInfo = productData(props);

	const [visitBlurb, showVisitBlurb] = useState(false);
	const [state, setState] = useReducer(reducer,
		{
			card: {},
		});
	const {
		card, noPayment,
	} = state;
	const {
		bodyBusy, saveOnly, darkMode, disabled, buttonText, withBorder, buttonPortal, btnContainer, otcCheckout,
	} = props;

	useEffect(() => {
		if (card.complete) {
			showVisitBlurb(true);
			if (props.prePurchase && props.cart && props.cart.product_pre_purchase) {
				$('html, body').animate({ scrollTop: '+=300px' },
					500);
			}
			// Send GA4 add payment info
			addPaymentInfo('Credit Card');
		} else {
			showVisitBlurb(false);
		}
	},
	[state.card]);

	useEffect(() => {
		const privateStripeElement = document.getElementsByClassName('__PrivateStripeElement')
		if (privateStripeElement[0])
			privateStripeElement[0].style.padding = '20px 20px 20px 10px';
	},
	[]);

	function checkCompletion() {
		if (!state.card.complete) {
			setState({
				card: {
					error: 'Please enter required credit card information.',
					complete: false,
				},
			})
			return false
		} else {
			return true
		}
	}

	async function submitPayment(e) {
		e.preventDefault();
		const {
			setBodyBusy, openCrossSell,
		} = props;
		setBodyBusy(true);
		if (!checkCompletion()) {
			setBodyBusy(false);
		}

		const res = await createTokenAndPostCheckout(props)
		if (!res) {
			setAlert('error',
				'Please check your credit card information and try again.')
			setBodyBusy(false)
		}
		if (res.success) {
			const {
				response, nextStep,
			} = res;
			setBodyBusy(false);
			setAlertNextPage('success',
				res.successMessage);
			if (response.cross_sell) {
				openCrossSell(nextStep,
					response.cross_sell);
			} else {
				window.location = nextStep
			}
		} else {
			setAlert('error',
				res.errorMessage);
			setBodyBusy(false)
		}
	}

	async function savePaymentInfo(e) {
		const { setBodyBusy } = props;
		e.preventDefault();
		setBodyBusy(true);
		if (!checkCompletion()) {
			setBodyBusy(false);
		}

		const response = await stripeTokenSave(props);
		if (!isEmpty(response.success)) {
			// ToDo: handle this update without a page reload.
			props.propogatePaymentInfo(response.response.existing_payments);
			setAlert('success',
				'Successfully updated credit card information.')
		} else if (response.error && (typeof response.error === 'string' || response.error instanceof String)) {
			setAlert('error',
				response.error)
		} else {
			setAlert('error',
				'Sorry, we could not save that payment method to your account. Contact care@apostrophe.com for further assistance.')
		}
		setBodyBusy(false)
	}

	function onChange(element) {
		setState({ card: element })
	}

	let total = 0;
	if (props.cart && props.cart.product_pre_purchase) {
		props.cart.product_pre_purchase.forEach(product => {
			total += product.price_cents / 100;
		})
	}

	const useUpdatedRegistration = get(window,
		'Yoderm.data.useUpdatedRegistration') || false;

	return (
		<form style={props.otcCheckout ? {
			width: '100%',
			marginTop: '20px',
			marginLeft: '-5px',
		} : { width: '100%' }}>
			<CreditCardInputWrapper
				darkMode={darkMode}
				withBorder={withBorder}
				data-cy={'CreditCardInputWrapper'}
				otcCheckout={props.otcCheckout}
				isPrepay={props.isPrepay}
			>
				<CardElement
					style={
						{
							base: {
								fontFamily: '"Maax", Tahoma, Arial, Helvetica, sans-serif',
								fontSmoothing: 'antialiased',
								color: `${variables.darkGrey}`,
							},
						}
					}
					className="stripe-element"
					onChange={onChange}
					data-cy={'CardElement'}
					option
				/>
			</CreditCardInputWrapper>
			<Error medCheckout={props.medCheckout} data-cy={'CCError'}>
				{card.error && card.error.message}
			</Error>

			{visitBlurb && props.prePurchase && props.cart && props.cart.product_pre_purchase &&
        <>
        	<Title>Confirm Order</Title>
        	<OrderConfirmationWrapper data-cy={'OrderConfirmationWrapper'}>
        		<CartWrapper data-cy={'CartWrapper'}>
        			{props.cart.product_pre_purchase.map(product => (
        				<CartItem data-cy={'CartItem'} key={product.name}>
        					<div className="name">{product.name} Prescription Credit (3 month supply)</div>
        					<div className="price">${product.price_cents/100}</div>
        				</CartItem>
        			))}
        			<CartItem data-cy={'CartItem'} light={true}>
        				<div className="name">Free Online Specialist Visit</div>
        				<div className="price">$0</div>
        			</CartItem>
        			<CartItem data-cy={'CartItem'} total={true}>
        				<div className="name">Total</div>
        				<div className="price">${total}</div>
        			</CartItem>
        		</CartWrapper>
        		{/* <BlurbWrapper>
              <DoctorImg doctorUrl={props.doctor.photoUrl}/>
              <Blurb>
                Once payment is complete your doctor will ask a few questions to learn more about your skin goals and medical history to recommend a optimal skincare treatment plan.
              </Blurb>
            </BlurbWrapper> */}
        	</OrderConfirmationWrapper>
        </>
			}
			{/* Legacy buttons */}
			{!useUpdatedRegistration && (buttonPortal ?
				ReactDOM.createPortal(
					<Button
						onClick={saveOnly ? savePaymentInfo : submitPayment}
						{...{
							bodyBusy,
							disabled,
							card,
							buttonText,
						}}
					/>,
					btnContainer.current
				)
				: (
					<Button
						onClick={saveOnly ? savePaymentInfo : submitPayment}
						{...{
							noPayment,
							bodyBusy,
							disabled,
							card,
							buttonText,
						}} />
				))}

			{!useUpdatedRegistration && productInfo?.disclaimer && <Disclaimer>{productInfo.disclaimer}</Disclaimer>}

			{/* "Normal" regRedesign buttons */}
			{useUpdatedRegistration && (buttonPortal ?
				ReactDOM.createPortal(
					<Button
						onClick={saveOnly ? savePaymentInfo : submitPayment}
						{...{
							bodyBusy,
							disabled,
							card,
							buttonText: buttonText ?? 'Submit payment',
							useUpdatedRegistration,
						}}
					/>
					,
					btnContainer.current
				)
				: (
					<UpdatedRegistrationButtonWrapper>
						<Button
							onClick={saveOnly ? savePaymentInfo : submitPayment}
							{...{
								noPayment,
								bodyBusy,
								disabled,
								card,
								buttonText: buttonText ?? 'Submit payment',
								useUpdatedRegistration,
							}}
						/>
					</UpdatedRegistrationButtonWrapper>
				))
			}

			{useUpdatedRegistration && <div style={{ textAlign: 'center' }}>
				<Typography variant={'caption'} color={'secondary'}>{productInfo.disclaimer}</Typography>
			</div>}
		</form>
	)
};

CardForm.defaultProps = {
	// checkoutUrl: '/ajax/patient/checkout_test/',
	// nextPage: '/yd/patient/dashboard/',
	successMessage: 'Thanks for your order! We\'ll continue to update you as your order status changes.',
	buttonText: 'Submit payment',
	saveOnly: false,
}

export default injectStripe(CardForm)
